import { defineComponent as n, createBlock as i, openBlock as a, unref as t } from "vue";
import { sizeNameToSize as r } from "@ds/components/Icon";
import o from "../../icons/generated/IconSpinner.vue2.js";
const u = /* @__PURE__ */ n({
  name: "RevSpinner",
  __name: "Spinner",
  props: {
    size: { default: "medium" },
    alternativeText: { default: "Loading" }
  },
  setup(m) {
    return (e, s) => (a(), i(t(o), {
      "alternative-text": e.alternativeText,
      class: "animate-spin text-inherit",
      size: t(r)[e.size]
    }, null, 8, ["alternative-text", "size"]));
  }
});
export {
  u as default
};
